// extracted by mini-css-extract-plugin
export default {"headerTitle":"Header_headerTitle__Vfl4P","headerSubtitle":"Header_headerSubtitle__9z+C5","userImage":"Header_userImage__cXTvr","notificationCount":"Header_notificationCount__S7GLG"};